export const GET_USER_TILE_ROLES = 'GET_USER_TILE_ROLES';
export const GET_USER_TILE_ROLES_SUCCESS = 'GET_USER_TILE_ROLES_SUCCESS';
export const GET_USER_TILE_ROLES_FAIL = 'GET_USER_TILE_ROLES_FAIL';
